//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { store, infoByBarCode } from '@/apis/receipt'
export default {
    components: {
    },
    data() {
        //表單校驗
        const rules = {
            url: [{ required: true, message: '請上傳文件！' }],

        };
        const formData = {
        };
        return {
            searchInput: '',
            scannerBuffer: '', // 掃碼槍輸入緩沖區
            scannerTimeout: null, // 掃碼槍輸入超時定時器
            productData: {
                barcode: '',
                productCode: '',
                name: '',
                upperLimit: '',
                lowerLimit: ''
            },
            resultMessage: '',
            resultStatus: '',
            id: 0,
            spinning: false,
            formData,
            rules,
            labelCol: { style: { width: '150px', }, },
        }
    },
    async mounted() {
        this.isAdmin = false;
        this.id = this.$route.params.id;
        if (this.id > 0) {
            await this.onPageLoad();
        }
        this.initScannerListener();
    },
    methods: {
        initScannerListener() {
            window.addEventListener('keypress', this.handleScannerInput);
        },
        handleScannerInput(event) {
            // 清除之前的超時定時器
            if (this.scannerTimeout) {
                clearTimeout(this.scannerTimeout);
            }

            // 處理掃碼槍輸入
            if (event.key === 'Enter') {
                // 掃碼完成，設置搜索內容並觸發搜索
                this.searchInput = this.scannerBuffer;
                this.handleSearch();
                this.scannerBuffer = '';
            } else {
                // 追加字符到緩沖區
                this.scannerBuffer += event.key;

                // 設置超時定時器（300ms無輸入則清空緩沖區）
                this.scannerTimeout = setTimeout(() => {
                    this.scannerBuffer = '';
                }, 300);
            }
        },
        handleSearch() {
            // this.searchInput = '4714508125382'
            if (this.searchInput) {
                console.log('搜索內容:', this.searchInput);
                // 模擬API調用獲取商品信息
                this.fetch(this.searchInput);
            }
        },
        fetch(barcode) {
            // 這裏應該是實際的API調用
            console.log('獲取商品信息:', barcode);

            // 模擬API返回數據
            setTimeout(() => {
                infoByBarCode({ barCode: barcode }).then(res => {
                    if (res.code != 200) {
                        this.$message.error("條碼不存在，請重新檢查條碼是否正確!")
                        return;
                    }
                    this.productData = {
                        id: res.data.id,
                        barcode: res.data.barcode,
                        productCode: res.data.item_code,
                        name: res.data.item_name,
                        upperLimit: res.data.max_weight,
                        lowerLimit: res.data.min_weight,
                    };
                })

                // this.$message.success(`成功獲取商品 ${barcode} 的信息`);
            }, 200);
        },
        handleGo() {
            this.onSubmit();
        },
        handleNoGo() {
            // 新增：清空緩沖區並準備重新掃碼
            this.scannerBuffer = '';
            this.searchInput = '';
            this.$message.info('已重置掃碼狀態，請重新掃碼');
            this.productData = {
                barcode: '',
                productCode: '',
                name: '',
                upperLimit: '',
                lowerLimit: ''
            };

        },
        async onPageLoad() {
            try {
                const res = await fetch(this.id);
                if (res.code == 0) {
                    // this.formData = res.data;
                    // this.formData.status = this.formData.status.toString();
                    // this.onLoadFile();
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },


        handleOnFormValidate(e, v) {
            e.preventDefault();
            console.log('onFormValidate', v);
            this.$refs.form.validate(valid => {
                console.log(valid);
                if (valid) {
                    this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async onSubmit() {
            const form = { ...this.formData };

            try {
                this.spinning = true;
                const res = await store({
                    barCode: this.productData.barcode,
                    itemCode: this.productData.productCode,
                    itemName: this.productData.name,
                });
                if (res.code == 200) {
                    this.$message.success('提交完成');
                    this.$router.push('/receipt');
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
